import React, { useEffect, useState } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useHolidayApi } from '@src/hooks/useHolidayApi';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { useSelector } from 'react-redux';
import { constants } from '@src/common/Utils/Constants';
import { IntakeForm } from './IntakeForm';
import { Breadcrumbs } from '@uhg-abyss/web/ui/Breadcrumbs';
import { mapBreadcrumbsData } from '@src/common/Utils/utils';

const Wrapper = styled('div', {
  '@screen >= $xs': {
    padding: '16px',
  },
  '@screen >= $xl': {
    padding: '32px 200px 0 200px',
  },
});

const StyledFlex = styled('div', {
  display: 'flex',
  flexBasis: '75%',
});

const Container = styled('div', {
  flexBasis: '100%',
});

const PageSubHeading = styled('h2', {
  color: 'rgb(0, 38, 119)',
  fontSize: '28px !important',
  fontWeight: '600',
  minHeight: '32px',
  lineHeight: '32px',
  marginBottom: '16px',
});
const PageDesc = styled('div', {
  color: `${constants.FONT_COLOR_GREY} !important`,
  fontSize: '15px',
  fontWeight: 400,
  letterSpacing: '0px',
  lineHeight: '24px',
  marginBottom: '16px',
});

export const Intake = () => {
  const [holidayApi, getHolidayApi] = useHolidayApi();
  const [displayErrorAlert, setDisplayErrorAlert] = useState(false);
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  const breadcrumbsData = useSelector((state) => {
    return state.BREADCRUMBS.data;
  });
  const postScheduleMeeting = useSelector((state) => {
    return state.POST_LEAD_GENERATION;
  });

  useEffect(() => {
    // Use the breadcrumbs data from Redux
    if (breadcrumbsData && Array.isArray(breadcrumbsData)) {
      const items = mapBreadcrumbsData(breadcrumbsData);
      setBreadcrumbItems(items);
    }
  }, [breadcrumbsData]); // Only re-run when breadcrumbs data or URL changes

  useEffect(() => {
    if (Object.keys(holidayApi?.data).length === 0) {
      getHolidayApi();
    }
  }, []);

  useEffect(() => {
    if (postScheduleMeeting.error) {
      setDisplayErrorAlert(true);
    } else {
      setDisplayErrorAlert(false);
    }
  }, [postScheduleMeeting.error]);

  return (
    <Wrapper>
      <StyledFlex>
        <Container>
          <Breadcrumbs
            size="11px"
            css={{
              fontWeight: 400,
              'abyss-breadcrumb-current': { fontWeight: 400 },
            }}
            items={breadcrumbItems}
          />
          {displayErrorAlert && (
            <Alert title="Error scheduling meeting" variant="error">
              {postScheduleMeeting?.data?.message ||
                'There was an error scheduling your meeting. Please try again later.'}
            </Alert>
          )}
          <PageSubHeading>Let's get you connected</PageSubHeading>
          <PageDesc>
            Thank you for your interest in our API solutions. To help us
            understand your organization's needs and recommend the best
            integration path, please complete the form below.
          </PageDesc>
          <IntakeForm />
        </Container>
      </StyledFlex>
    </Wrapper>
  );
};
